module.exports = __webpack_public_path__ + "static/media/bronzeTop1D.a4ae558f.webp";